import { render, staticRenderFns } from "./VWMA_SettingsWindow.vue?vue&type=template&id=35e11039&scoped=true"
import script from "./VWMA_SettingsWindow.vue?vue&type=script&lang=js"
export * from "./VWMA_SettingsWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e11039",
  null
  
)

export default component.exports